<div class="card">
    <h4 *ngIf="title" [style]="headerStyle">
        {{ title }}
    </h4>

    <form nz-form [formGroup]="labForm" [nzLayout]="'inline'">
        <div
            *ngFor="let field of fields"
            [style]="
                field.type === 'break'
                    ? 'flex-basis: 100%;height: 0;min-height: unset;'
                    : field.level === 'child' || field.level === 'parent'
                    ? 'width: 100%;'
                    : 'width: 100%;display: flex;'
            "
            [class]="field.type !== 'break' ? 'req-row' : ''"
        >
            <div *ngIf="field.type !== 'break'">
                <div [style]="field.children?.length ? 'display: flex;gap: 10px' : ''">
                    <nz-form-item
                        style="
                            margin: 0;
                            align-items: flex-start;
                            flex-wrap: nowrap;
                        "
                    >
                        <nz-form-label
                            class="input-label"
                            [style.--input-color]="inputColor"
                            [style]="
                                field.type === 'boolean'
                                    ? 'order: 2;'
                                    : 'order: 1;'
                            "
                            *ngIf="field.label"
                            [nzNoColon]="field.type === 'boolean'"
                            [nzFor]="field.id"
                            [nzRequired]="field.required"
                            style="flex: none !important"
                            >{{ field.label }}</nz-form-label
                        >

                        <nz-form-control
                            [ngStyle]="{
                                order: field.type === 'boolean' ? '1' : '2'
                            }"
                            style="flex: none !important"
                            nzErrorTip="Error"
                        >
                            <my-health-custom-checkbox
                                *ngIf="field.type === 'boolean'; else inputTmp"
                                [formControlName]="field.id"
                            ></my-health-custom-checkbox>

                            <ng-template #inputTmp>
                                <input
                                    *ngIf="
                                        field.type === 'string' ||
                                        field.type === 'number'
                                    "
                                    style="width: auto; max-width: 140px"
                                    nz-input
                                    [type]="field.type"
                                    [formControlName]="field.id"
                                    [id]="field.id"
                                />
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>

                    <my-health-input-element
                        *ngFor="let childField of field.children"
                        [style]="
                            childField.type !== 'boolean' ? 'flex-grow: 1;' : ''
                        "
                        [inputForm]="labForm"
                        [field]="childField"
                    ></my-health-input-element>
                </div>

                <p *ngIf="field.description" class="description">
                    {{ field.description }}
                </p>
            </div>

            <div
                [style]="
                    'display: block;' +
                    (field.elements?.length ? 'width: 100%;' : '')
                "
            >
                <my-health-lab-req-element
                    *ngFor="let element of field.elements"
                    [parentId]="field.id"
                    [element]="element"
                    [values]="values"
                ></my-health-lab-req-element>
            </div>
        </div>
    </form>
</div>
